import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface InteractiveListState {
  isCollapsed: boolean;
}

const initialState: InteractiveListState = {
  isCollapsed: false,
};

const interactiveListSlice = createSlice({
  name: "interactiveList",
  initialState,
  reducers: {
    toggleCollapse(state) {
      state.isCollapsed = !state.isCollapsed;
    },
    setCollapse(state, action: PayloadAction<boolean>) {
      state.isCollapsed = action.payload;
    },
  },
});

export const { toggleCollapse, setCollapse } = interactiveListSlice.actions;

export default interactiveListSlice.reducer;
